/** Six-column spans: preserve order and fill each row without a trailing orphan when possible. */
export function roundGridSpans(count: number, columns: 2 | 3): number[] {
  const spans: number[] = [];
  let remaining = count;

  while (remaining > 0) {
    const rowSize =
      columns === 3 && remaining === 4 ? 2 : Math.min(columns, remaining);
    spans.push(...Array<number>(rowSize).fill(6 / rowSize));
    remaining -= rowSize;
  }

  return spans;
}

/** Groups break the outer grid into runs; an odd final standalone fills its row. */
export function fullWidthRoundSections(
  sections: { id: string; name: string | null }[],
): Set<string> {
  const fullWidth = new Set<string>();
  let unpaired: string | null = null;

  for (const section of sections) {
    if (section.name != null) {
      fullWidth.add(section.id);

      if (unpaired != null) {
        fullWidth.add(unpaired);
      }

      unpaired = null;
    } else {
      unpaired = unpaired == null ? section.id : null;
    }
  }

  if (unpaired != null) {
    fullWidth.add(unpaired);
  }

  return fullWidth;
}
